import httpService from './httpService';

export type InboxInfo = Record<string, any[]>;

export async function getInboxInfo(): Promise<InboxInfo> {
  const response = await httpService.get('/notifications/inbox');
  return response.data as InboxInfo;
}
